module.exports = __webpack_public_path__ + "static/media/close-icon-gray.520ed568.svg";